import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type UploadAnalyticsCommonParams } from './uploadAnalyticsTypes';
import META from './useTrackUploadPartStarted.meta';

export type UseTrackUploadPartStartedParams = UploadAnalyticsCommonParams & {
  part_number: number;
  part_size_bytes?: number;
  retry_count: number;
  max_retry_count?: number;
  start_reason: 'initial' | 'retry';
  upload_url_type: 'primary' | 'fallback';
};

export const useTrackUploadPartStarted = () => {
  const { track } = useAnalyticsUtilities();

  const trackUploadPartStarted = useCallback(
    (params: UseTrackUploadPartStartedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackUploadPartStarted };
};
